import { BenchwiseStateView } from '../../../generated/model/benchwiseStateView';
import { BenchmarkCompanyView, BenchmarkView } from '../../../generated/model/models';

export enum BenchmarkContextActionTypes {
  ResetBenchmark = 'benchmarks/RESET_BENCHMARK',
  SetActiveBenchmark = 'benchmarks/SET_ACTIVE_BENCHMARK',
  SetBenchmarkCompanies = 'benchmarks/SET_BENCHMARK_COMPANIES',
  SetActiveBenchmarkCompanyId = 'benchmarks/SET_ACTIVE_BENCHMARK_COMPANY_ID',
  SetPagination = 'benchmarks/SET_PAGINATION_STATE',
  SetIsLoadingState = 'benchmarks/SET_IS_LOADING_STATE',
  SetClickedBenchmarkTabName = 'benchmarks/SET_CLICKED_BENCHMARK_TAB_NAME',
  SetTestedParty = 'benchmarks/SET_TESTED_PARTY',
  IncrementRefreshKey = 'benchmarks/INCREMENT_REFRESH_KEY',
  SetCompanyFilter = 'benchmarks/SET_COMPANY_FILTER',
}

export type BenchmarkContextActions =
  | { type: BenchmarkContextActionTypes.ResetBenchmark }
  | { type: BenchmarkContextActionTypes.SetActiveBenchmark; payload: BenchmarkView }
  | {
      type: BenchmarkContextActionTypes.SetBenchmarkCompanies;
      payload: { companies: BenchmarkCompanyView[]; benchwiseState?: BenchwiseStateView };
    }
  | { type: BenchmarkContextActionTypes.SetActiveBenchmarkCompanyId; payload: string }
  | { type: BenchmarkContextActionTypes.SetPagination; payload: PaginationStateInterface }
  | { type: BenchmarkContextActionTypes.SetIsLoadingState; payload: boolean }
  | { type: BenchmarkContextActionTypes.SetClickedBenchmarkTabName; payload: string }
  | { type: BenchmarkContextActionTypes.SetTestedParty; payload: TestedPartyInterface }
  | { type: BenchmarkContextActionTypes.IncrementRefreshKey }
  | { type: BenchmarkContextActionTypes.SetCompanyFilter; payload: string };

export type BenchmarkContextProps = {
  activeBenchmark?: BenchmarkView;
  activeCompanyId?: string;
  dataset?: string;
  companies: BenchmarkCompanyView[];
  benchwiseState?: BenchwiseStateView;
  pagination: PaginationStateInterface;
  isLoading: boolean;
  activeTab: string;
  testedParty?: TestedPartyInterface;
  refreshKey?: number;
  companyFilter: string;
};

export interface PaginationStateInterface {
  page: number;
  size: number;
  totalPages: number;
  totalElements: number;
}

export interface TestedPartyInterface {
  uploaded?: boolean;
  companyId?: string;
}

export type BenchmarkProviderProps = { children: React.ReactNode };
